<template>
  <div class="journey-canvas">
    <div class="canvas-flow">
      <!-- Empty state -->
      <div v-if="!nodes || nodes.length === 0" class="empty-canvas" @click="showAddModal(0)">
        <div class="empty-canvas-inner">
          <div class="empty-icon">
            <i class="bx bx-git-branch"></i>
          </div>
          <h5>Monte sua jornada</h5>
          <p>Clique nos steps da paleta lateral ou clique aqui para comecar</p>
          <button class="btn-add-first" @click.stop="showAddModal(0)">
            <i class="bx bx-plus mr-1"></i> Adicionar primeiro step
          </button>
        </div>
      </div>

      <!-- Nodes list -->
      <draggable
        v-model="localNodes"
        handle=".node-drag-handle"
        animation="200"
        ghost-class="ghost-node"
        @end="onReorder"
      >
        <div v-for="(node, index) in localNodes" :key="node.id || node._tempId" class="flow-step">
          <!-- Connector -->
          <div class="connector" v-if="index > 0">
            <div class="connector-line"></div>
            <div class="connector-arrow"></div>
            <button class="btn-add-between" @click.stop="showAddModal(index)" title="Adicionar novo step">
              <i class="bx bx-plus"></i>
            </button>
          </div>

          <JourneyNodeCard
            :node="node"
            :all-nodes="allNodes"
            :selected-node-id="selectedNodeId"
            :email-templates="emailTemplates"
            :wa-templates="waTemplates"
            :statuses="statuses"
            :groups="groups"
            :tags="tags"
            :forms="forms"
            :journeys-list="journeysList"
            :follow-up-rules="followUpRules"
            :depth="0"
            @select-node="$emit('select-node', $event)"
            @remove-node="$emit('remove-node', $event)"
            @add-to-branch="handleAddToBranch"
          />
        </div>
      </draggable>

      <!-- Add node at end -->
      <div class="connector connector-end" v-if="localNodes.length > 0">
        <div class="connector-line"></div>
        <div class="connector-arrow"></div>
        <button class="btn-add-between" @click="showAddModal(localNodes.length)" title="Adicionar novo step">
          <i class="bx bx-plus"></i>
        </button>
      </div>
    </div>

    <!-- Add Node Modal -->
    <AddNodeModal v-model="showNodeModal" :show-triggers="insertIndex === 0 && localNodes.length === 0" @add-node="handleAddNodeFromModal" />
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import AddNodeModal from './modals/AddNodeModal.vue'
import JourneyNodeCard from './JourneyNodeCard.vue'

export default {
  components: { draggable, AddNodeModal, JourneyNodeCard },
  props: {
    nodes: { type: Array, default: () => [] },
    allNodes: { type: Array, default: () => [] },
    selectedNodeId: { default: null },
    emailTemplates: { type: Array, default: () => [] },
    waTemplates: { type: Array, default: () => [] },
    statuses: { type: Array, default: () => [] },
    groups: { type: Array, default: () => [] },
    tags: { type: Array, default: () => [] },
    forms: { type: Array, default: () => [] },
    journeysList: { type: Array, default: () => [] },
    followUpRules: { type: Array, default: () => [] }
  },
  data () {
    return {
      showNodeModal: false,
      insertIndex: null,
      branchContext: null
    }
  },
  computed: {
    localNodes: {
      get () { return this.nodes },
      set (val) { this.$emit('reorder-nodes', val) }
    }
  },
  methods: {
    onReorder () {},
    showAddModal (index) {
      this.branchContext = null
      this.insertIndex = index
      this.showNodeModal = true
    },
    handleAddToBranch ({ parentNodeId, branchType }) {
      this.branchContext = { parentNodeId, branchType }
      this.insertIndex = null
      this.showNodeModal = true
    },
    handleAddNodeFromModal (nodeDef) {
      this.showNodeModal = false
      if (this.branchContext) {
        this.$emit('add-node-at', {
          node: {
            ...nodeDef,
            parent_node_id: this.branchContext.parentNodeId,
            branch_type: this.branchContext.branchType
          },
          index: -1
        })
        this.branchContext = null
      } else {
        this.$emit('add-node-at', { node: nodeDef, index: this.insertIndex })
      }
    }
  }
}
</script>

<style scoped>
.journey-canvas {
  display: flex;
  justify-content: center;
  min-height: 100%;
  padding: 24px 0;
  min-width: min-content;
}
.canvas-flow {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: max-content;
  min-width: 360px;
}

.empty-canvas {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 60px 40px;
  border: 2px dashed #e9ecef;
  border-radius: 14px;
  cursor: pointer;
  width: 100%;
  background: #fff;
  transition: all 0.15s;
}
.empty-canvas:hover {
  border-color: #556ee6;
  background: #f8f9ff;
}
.empty-canvas-inner { max-width: 280px; margin: 0 auto; }
.empty-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f0f4ff;
  color: #556ee6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-bottom: 16px;
}
.empty-canvas h5 { font-size: 16px; font-weight: 600; color: #495057; margin-bottom: 8px; }
.empty-canvas p { font-size: 14px; color: #6c757d; margin: 0; }
.btn-add-first {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 12px;
  padding: 8px 16px;
  border: 1px solid #e9ecef;
  background: #fff;
  border-radius: 6px;
  font-size: 13px;
  color: #556ee6;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-add-first:hover {
  border-color: #556ee6;
  background: #f0f4ff;
}

.connector {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 48px;
}
.connector-line {
  width: 2px;
  flex: 1;
  background: linear-gradient(to bottom, #d0d5dd, #e9ecef);
}
.connector-arrow {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #d0d5dd;
}
.btn-add-between {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: 1.5px dashed #d0d5dd;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #adb5bd;
  font-size: 14px;
  z-index: 1;
  transition: all 0.2s;
  opacity: 0;
}
.connector:hover .btn-add-between { opacity: 1; }
.btn-add-between:hover {
  border-color: #556ee6;
  border-style: solid;
  color: #556ee6;
  background: #f0f4ff;
  transform: translateY(-50%) scale(1.15);
}

.ghost-node { opacity: 0.4; }
.flow-step { width: 100%; display: flex; flex-direction: column; align-items: center; }
</style>
